import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { DataTablesService } from '../../../core';
import { TituloReceberPagamento } from './titulo-receber-pagamento';

@Component({
    selector: 'sgt-titulo-receber-pagamento',
    templateUrl: './titulo-receber-pagamento.component.html',
    styleUrls: ['./titulo-receber-pagamento.component.less']
})
export class TituloReceberPagamentoComponent implements OnChanges {
    @Input() entities: TituloReceberPagamento[];
    dataTable: any;

    constructor(private dataTablesService: DataTablesService) { }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'entities') {
                if (changes[propName].isFirstChange()) {
                    this.showTable();
                }
            }
        }
    }

    private showTable() {
        this.dataTablesService.showTable('#tableTituloReceberPagamento', this.dataTable, {
            order: [[0, 'asc']], // sequência asc
            columnDefs: [
                {orderable: true, targets: [0]}
            ],
            paging: false,
            searching: false,
            info: false,
            scrollX: true,
            scrollCollapse: true
        }).then(dataTable => this.dataTable = dataTable);
    }
}
